<script setup lang="ts">
const webAppURL = import.meta.env.VITE_WEBAPP_URL;
</script>

<template>
  <div class="adm-project-page">
    <df-alert show persistent>
      <div style="display: grid; gap: var(--gap-md)">
        <p>Denne siden har blitt flyttet til administrasjon i webapp.</p>

        <df-button :href="`${webAppURL}/admin/projects`" elevate> Gå til webapp </df-button>
      </div>
    </df-alert>
  </div>
</template>

<style scoped></style>
